import Vue from "vue";
import Vuex from "vuex";
import {
  list,
  getEntregaGraphs,
  exportEntregaGraphsPDF,
  getTasksWithApprovals,
  getPlanos,
  getProtocolos,
  getConfig,
  getPlano,
} from "@/helpers/api/entrega";
import {getProjectRequest, isCurrentProjectRequest} from '@/helpers/projectContext';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    listadoEntrega: {
      status: 99,
      count: 0,
      total_entrega: 0,
      data: [],
    },
    activePlanos: [],
    listadoEntregaTotal: 0,
    listadoProtocolos: {
      status: 99,
      count: 0,
      total_entrega: 0,
      data: [],
    },
    createEntregaModal: false,
    entregaConfigModal: false,
    createProtocoloModal: false,
    config: {},
    listingOrder: 1,
    selectedType: 2,
    currentEntrega: null,
    initialDataEntrega: null,
    borradorEntrega: null,
    entregaGraphsData: {
      status: 99,
      data: null,
    },
    planos: {
      status: 99,
      data: null,
      total: 0,
    },
    addPlanoModal: false,
    editPlanoModal: false,
    controlPlanoModal: false,
    planoTotalViewerModal: false,
    planoTotalViewerPlanoId: null,
    selectedPlanoId: null,
    loadingChangeVisualizationStatus: [],
    tasksWithApprovals: [],
    draftToLoad: null,
  },
  mutations: {
    setListadoEntrega(state, entregas) {
      state.listadoEntrega = entregas;
      state.listadoEntregaTotal = entregas.total_entrega;
    },
    setCurrentEntrega(state, entrega) {
      state.currentEntrega = entrega;
    },
    setBorradorEntrega(state, entrega) {
      state.borradorEntrega = entrega;
    },
    setSelectedType(state, type) {
      state.selectedType = type;
    },
    setActivePlanos(state, data) {
      state.activePlanos = data;
    },
    setListingOrder(state) {
      let currentStatus = state.listingOrder;
      if (currentStatus === 4) {
        currentStatus = 1;
      } else {
        currentStatus++;
      }
      state.listingOrder = currentStatus;
    },
    setCreateEntregaModal(state, status) {
      state.createEntregaModal = status;
    },
    setAddPlanoModal(state, status) {
      state.addPlanoModal = status;
    },
    setEditPlanoModal(state, status) {
      state.editPlanoModal = status;
    },
    setControlPlanoModal(state, status) {
      state.controlPlanoModal = status;
    },
    setPlanoTotalViewerModal(state, status) {
      state.planoTotalViewerModal = status;
    },
    setPlanoTotalViewerPlanoId(state, id) {
      state.planoTotalViewerPlanoId = id;
    },
    setSelectedPlanoId(state, id) {
      state.selectedPlanoId = id;
    },
    setEntregaConfigModal(state, status) {
      state.entregaConfigModal = status;
    },
    setCreateProtocoloModal(state, status) {
      state.createProtocoloModal = status;
    },
    setInitialDataEntrega(state, data) {
      state.initialDataEntrega = data;
    },
    setEntregaGraphsData(state, data) {
      state.entregaGraphsData = data;
    },
    setPlanos(state, data) {
      state.planos = data;
    },
    setConfig(state, data) {
      state.config = data;
    },
    setProtocolos(state, data) {
      state.listadoProtocolos = data;
    },
    setTasksWithApprovals(state, tasks) {
      state.tasksWithApprovals = tasks;
    },
    setDraftToLoad(state, draft) {
      state.draftToLoad = draft;
    },
    addLoadingChangeVisualizationStatus(state, newItemID) {
      const changingStatus = [...state.loadingChangeVisualizationStatus];
      const found = changingStatus.find((item) => item === newItemID);
      if (!found) {
        changingStatus.push(newItemID);
      }
      state.loadingChangeVisualizationStatus = changingStatus;
    },
    removeLoadingChangeVisualizationStatus(state, itemID) {
      const changingStatus = [...state.loadingChangeVisualizationStatus];
      const foundIndex = changingStatus.findIndex((item) => item === itemID);
      if (foundIndex !== -1) {
        changingStatus.splice(foundIndex, 1);
      }
      state.loadingChangeVisualizationStatus = changingStatus;
    },
    resetForProject(state) {
      state.listadoEntrega = { status: 99, count: 0, total_entrega: 0, data: [] };
      state.listadoProtocolos = { status: 99, count: 0, total_entrega: 0, data: [] };
      state.entregaGraphsData = { status: 99, data: null };
      state.planos = { status: 99, data: null, total: 0 };
      state.activePlanos = [];
      state.tasksWithApprovals = [];
      state.listadoEntregaTotal = 0;
      state.currentEntrega = null;
      state.initialDataEntrega = null;
      state.borradorEntrega = null;
      state.config = {};
      state.selectedPlanoId = null;
      state.planoTotalViewerPlanoId = null;
      state.draftToLoad = null;
      state.loadingChangeVisualizationStatus = [];
      state.createEntregaModal = false;
      state.entregaConfigModal = false;
      state.createProtocoloModal = false;
      state.addPlanoModal = false;
      state.editPlanoModal = false;
      state.controlPlanoModal = false;
      state.planoTotalViewerModal = false;
      },
      },
  actions: {
    async getActivePlano(context, query) {
      const request = getProjectRequest(query.project_id);
      const data = query;
      const plano = await getPlano(data);
      if (isCurrentProjectRequest(request.projectId, request.generation) && plano.code === 200) {
        context.commit("setActivePlanos", plano.planos);
      }
    },
    async getTasksWithApprovals(context, query) {
      const request = getProjectRequest(query.project_id);
      const data = {
        project_id: query.project_id,
      };

      try {
        const response = await getTasksWithApprovals(data);

        if (isCurrentProjectRequest(request.projectId, request.generation) && response.code === 200) {
          context.commit("setTasksWithApprovals", response.tasks);
          return response.tasks;
        }

        return null;
      } catch (error) {
        console.error("Error fetching tasks with approvals:", error);
        return null;
      }
    },
    async getEntregaGraphsData(context, query) {
      const request = getProjectRequest(query.project_id);
      const data = {
        project_id: query.project_id,
      };
      
      let graphsData = { status: 99, data: null };
      context.commit("setEntregaGraphsData", graphsData);
      
      try {
        const response = await getEntregaGraphs(data);
        
        if (isCurrentProjectRequest(request.projectId, request.generation) && response.code === 200) {
          context.commit("setEntregaGraphsData", {
            status: 1,
            data: response,
          });
          return response;
        } else if (isCurrentProjectRequest(request.projectId, request.generation)) {
          console.error("Error fetching entrega graphs data:", response);
          context.commit("setEntregaGraphsData", { 
            status: 0, 
            data: null 
          });
        }
      } catch (error) {
        console.error("Error in getEntregaGraphsData:", error);
        if (isCurrentProjectRequest(request.projectId, request.generation)) context.commit("setEntregaGraphsData", {
          status: 0, 
          data: null 
        });
      }
    },
    async exportEntregaGraphsPDF(context, query) {
			console.log("Exporting entrega graphs PDF with query:", query);
      return exportEntregaGraphsPDF({
        project_id: query.project_id,
      });
    },
    async getPlanos(context, query) {
      const request = getProjectRequest(query.project_id);
      let page = 1;
      let per_page = 50;
      if (query.page) {
        page = query.page;
      }
      const data = {
        project_id: query.project_id,
        start: per_page * (page - 1),
        limit: per_page,
      };
      let graphsData = { status: 99, data: [], total: 0 };
      context.commit("setPlanos", graphsData);
      const planos = await getPlanos(data);
      if (isCurrentProjectRequest(request.projectId, request.generation) && planos.code === 200) {
        context.commit("setPlanos", {
          status: 1,
          data: planos.planos,
          total: planos.total_planos || planos.planos.length,
        });
      }
    },
    async getConfig(context, query) {
      const request = getProjectRequest(typeof query === "object" ? query.project_id : query);
      let config = await getConfig({ project_id: query });
      if (isCurrentProjectRequest(request.projectId, request.generation) && config.code == 200) {
        context.commit("setConfig", config.config);
      }
    },
    async getProtocolos(context, query) {
      const request = getProjectRequest(query.project_id);
      let page = 1;
      let per_page = 200;
      if (query.page) {
        page = query.page;
      }
      const data = {
        project_id: query.project_id,
        start: per_page * (page - 1),
        limit: per_page,
      };
      let graphsData = {
        status: 99,
        count: 0,
        total_entrega: 0,
        data: [],
      };
      context.commit("setProtocolos", graphsData);
      const protocolos = await getProtocolos(data);
      if (isCurrentProjectRequest(request.projectId, request.generation) && protocolos.code === 200) {
        context.commit("setProtocolos", {
          status: 1,
          data: protocolos.protocolos,
        });
      }
    },
    async getEntrega(context, query) {
      const request = getProjectRequest(query.project_id);
      let status = 1;
      let page = 1;
      let per_page = 50;
      if (context.state.selectedType === 3) {
        status = 3;
      }
      if (query.page) {
        page = query.page;
      }

      const data = {
        project_id: query.project_id,
        status,
        order: context.state.listingOrder,
        start: per_page * (page - 1),
        limit: per_page,
        filtered_specialties: query.filtered_specialties,
        filtered_subjects: query.filtered_subjects,
        filtered_responsable: query.filtered_responsable,
      };

      // Add additional filters if they exist in the query
      if (query.numero_id) {
        data.numero_id = query.numero_id;
      }
  
      if (query.nivel) {
        data.nivel = query.nivel;
      }
  
      if (query.zona) {
        data.zona = query.zona;
      }

			if(query.ejes_alfabeticos && query.ejes_alfabeticos.length > 0) {
				data.ejes_alfabeticos = query.ejes_alfabeticos;
			}
			if(query.ejes_alfabeticos_b && query.ejes_alfabeticos_b.length > 0) {
				data.ejes_alfabeticos_b = query.ejes_alfabeticos_b;
			}
			
			if (query.ejes_numericos && query.ejes_numericos.length > 0) {
				data.ejes_numericos = query.ejes_numericos;
			}
			if(query.ejes_numericos_b && query.ejes_numericos_b.length > 0) {
				data.ejes_numericos_b = query.ejes_numericos_b;
			}

      if (query.supervisor_ids && query.supervisor_ids.length > 0) {
        data.supervisor_ids = query.supervisor_ids;
      }

      if (query.estados && query.estados.length > 0) {
        data.estados = query.estados;
      }

      if (query.fecha_critica) {
        data.fecha_critica = query.fecha_critica;
      }

      let listing = {
        status: 99,
        count: 0,
        total_entrega: 0,
        data: [],
      };
      context.commit("setListadoEntrega", listing);
      const entregas = await list(data);
      if (isCurrentProjectRequest(request.projectId, request.generation) && entregas.code === 200) {
        context.commit("setListadoEntrega", {
          status: 1,
          count: entregas.entrega.length,
          data: entregas.entrega,
          total_entrega: entregas.total_entrega,
        });
      }
    },
    updateEntregaLocally(context, newEntregaData) {
      const entregaIndex = context.state.listadoEntrega.data.findIndex(
        (entrega) => {
          return entrega.id === newEntregaData.id;
        }
      );
      if (entregaIndex !== -1) {
        const entregas = [...context.state.listadoEntrega.data];
        entregas[entregaIndex] = newEntregaData;
        context.commit("setListadoEntrega", {
          status: 1,
          count: context.state.listadoEntrega.count,
          data: entregas,
          total_entrega: context.state.listadoEntrega.total_entrega,
        });
      }
    },
  },
  getters: {
    currentEntrega: (state) => {
      return state.currentEntrega;
    },
  },
});

export default store;